import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const SeeAllButton = styled(Button)`
  padding: ${({ theme }) => theme.spacing["2"]};
  padding-left: ${({ theme }) => theme.spacing["3"]};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const SectionListTitleWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]};
`;
